import { useMemo } from "react";
import { lazy } from "react";
import { useAuth } from "../context/AuthContext";
import { FORM_REGISTRY } from "./registry";

// Default/fallback form – our generic eCRF
const DefaultECRF = lazy(() => import("./default_ecrf"));

/**
 * Normalise clinic claim to a file-friendly slug.
 * "Addenbrooks 2025" -> "addenbrooks_2025"
 */
export function slugifyClinicToken(token) {
  return String(token || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}

/**
 * Returns the React component that should be rendered for the current clinic.
 */
export function useClinicFormComponent() {
  const { clinicToken } = useAuth();

  return useMemo(() => {
    const slug = slugifyClinicToken(clinicToken);
    const Component = (slug && FORM_REGISTRY[slug]) || DefaultECRF;

    return { Component, slug, clinicToken };
  }, [clinicToken]);
}
